import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { CustomFieldPlainText } from "~/components/CustomFields/CustomFieldInput/CustomFieldPlainText";
import { useCurrentWorkspace } from "~/providers/CurrentWorkspaceProvider";
import { useUpdateItemsCustomFieldValue } from "~/utils/CustomFields/useUpdateItemsCustomFieldValue";
export const PrivateAssetCustomFieldPlainText = /*#__PURE__*/ memo((param)=>{
    let { field, trackingLocation, canEditCustomFields, assetId, ...rest } = param;
    const { updateItemsCustomFieldValue } = useUpdateItemsCustomFieldValue();
    const { currentWorkspace } = useCurrentWorkspace();
    const workspaceId = currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.id;
    const onSubmit = useCallback(async (value)=>{
        if (!workspaceId) {
            return;
        }
        await updateItemsCustomFieldValue({
            assetIds: [
                assetId
            ],
            baseCustomField: field,
            nextPlainTextValue: value,
            trackingLocation,
            workspaceId
        });
    }, [
        updateItemsCustomFieldValue,
        assetId,
        field,
        trackingLocation,
        workspaceId
    ]);
    return /*#__PURE__*/ _jsx(CustomFieldPlainText, {
        ...rest,
        onSubmit: canEditCustomFields ? onSubmit : undefined,
        field: field
    });
});
PrivateAssetCustomFieldPlainText.displayName = "PrivateAssetCustomFieldPlainText";
